import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { TableWrapper } from "@portal/BaseComponents/Table/Components/style";
import { defaultColumnDefs } from "@portal/BaseComponents/Table/default";
import { Formats } from "@portal/hooks/use-formats";
import { useCreditNotesQuery } from "@portal/queries/credit-notes-query";
import { tableAtom } from "@portal/store/table/table";
import { CreditMemo } from "@portal/types/entities/credit-memo";
import { Table } from "@sinecycle/growcomponents";
import produce from "immer";
import { useAtom } from "jotai";
import { useColumns } from "./Columns/useColumns";

interface CreditNotesProps {
  extra: Formats;
}
function CreditNotes(props: CreditNotesProps) {
  const [tableValue, setTable] = useAtom(tableAtom);
  const { data, isLoading } = useCreditNotesQuery({
    page: tableValue.currentPage,
    size: 10,
    filters: {},
  });
  const { defaultColConfigs } = useColumns(props.extra);

  return (
    <TableWrapper style={{ paddingTop: "24px" }}>
      <Table<CreditMemo>
        loading={isLoading}
        gridProps={{
          rowData: data?.list,
          columnDefs: defaultColConfigs,
          defaultColDef: {
            ...defaultColumnDefs,
            autoHeight: false,
            sortable: false,
            flex: 1,
          },
          animateRows: true,
          suppressMovableColumns: true,
          components: cellComponents,
          unSortIcon: true,
          enableCellTextSelection: true,
        }}
        tableState={tableValue}
        handlePageChange={(page) => {
          setTable((value) => {
            return produce(value, (draft) => {
              draft.currentPage = page;
              return draft;
            });
          });
        }}
        sortMode={{
          type: "remote",
          onSortChange: () => {},
        }}
        enableColumnCustom={{
          type: "header-only",
          content: {
            preserve: {
              type: "LOCAL",
              storageKey: "CREDIT_MEMO_PORTAL",
            },
           
          },
        }}
      />
    </TableWrapper>
  );
}

export { CreditNotes };
